const mutations = {
    setBetaFeatureOwnerAccess: (state, payload) => {
        state.betaFeatureOwnerAccess = payload
    },
    setShowQrisManagementMenu: (state, payload) => {
        state.showQrisManagementMenu = payload
    },
    setSapaan: (state, sapaan) => {
        state.sapaan = sapaan
    },
    setAgama: (state, agama) => {
        state.agama = agama
    },
    setKaryawanAll: (state, res) => {
        state.karyawanAll = res.data.data
    },
    setKonsumen: (state, res) => {
        state.konsumen = res.data.data
    },
    setKonsumenTiny: (state, res) => {
        state.konsumenTiny = res.data.data
    },
    setTahapan: (state, res) => {
        state.tahapan = res.data.data
    },
    setMesinAll: (state, res) => {
        state.mesinAll = res.data.data
    },
    setAkunKeuangan: (state, res) => {
        state.akunKeuangan = res.data.data
    },
    setAkunDebit: (state, res) => {
        state.akunDebit = res.data.data
    },
    setDataMCoin: (state, {data}) => {
        state.dataMCoin = data
    },
    setShortcode: (state, payload) => {
        state.shortcode = payload;
    },
    setAkunEDC: (state, res) => {
        state.akunEDC = res.data.data
    },
    setWorkshop: (state, res) => {
        state.workshop = res.data.data
    },
    setAkunKeuanganGlobal: (state, res) => {
        state.akunKeuanganGlobal = res.data.data
    },
    setFinancialAccountFund: (state, res) => {
        state.financialAccountFund = res.data.data
    },
    setListAssetsAccount: (state, res) => {
        state.listAssetsAccount = res.data.data
    },
    setListKeuanganKasOutlet: (state, res) => {
        state.listKeuanganKasOutlet = res.data.data
    },
    setListKeuanganKasWorkshop: (state, res) => {
        state.listKeuanganKasWorkshop = res.data.data
    },
    setListKeuanganBiaya: (state, res) => {
        state.listKeuanganBiaya = res.data.data
    },
    setListKeuanganOwner: (state, res) => {
        state.listKeuanganOwner = res.data.data
    },
    setListBiayaItemKategori: (state, res) => {
        state.listBiayaItemKategori = res.data.data
    },
    setAclList: (state, data) => {
        state.aclList = data
    },
    setIsFetchBetaOwner: (state, payload) => {
        state.isFetchBetaOwner = payload
    },
    setIsWebview: (state, payload) => {
        state.isWebview = payload
    },
    setInitRoute: (state, payload) => {
        state.initRoute = payload
    },
    setOpenBetaModal: (state, payload) => {
        state.isOpenBetaModal = payload
    },
    setTopServiceSummary: (state, payload) => {
        state.topServiceSummary = payload
    },
    setWhitelabelSetting: (state, payload) => {
        state.whitelabelSetting = payload
    },
	setIswhitelabel: (state, payload) => {
        state.isWhitelabel = payload
    },
}

export default mutations